export const LOADING_PROJECT = "LOADING_PROJECT";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const GET_PROJECT_ID = "GET_PROJECT_ID";
export const REMOVE_PROJECT = "REMOVE_PROJECT";
export const ADD_PROJECT = "ADD_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const GET_PROJECT_TASK = "GET_PROJECT_TASK";
export const ADD_PROJECT_TASK = "ADD_PROJECT_TASK";
export const REMOVE_PROJECT_TASK = "REMOVE_PROJECT_TASK";
export const UPDATE_PROJECT_TASK = "UPDATE_PROJECT_TASK";
export const UPDATE_PROJECT_TASK_ID = "UPDATE_PROJECT_TASK_ID";
export const GET_PROJECT_ASSIGNEES = "GET_PROJECT_ASSIGNEES";
export const GET_PROJECT_MILESTONE = "GET_PROJECT_MILESTONE";
export const ADD_PROJECT_MILESTONE = "ADD_PROJECT_MILESTONE";
export const REMOVE_PROJECT_MILESTONE = "REMOVE_PROJECT_MILESTONE";
export const UPDATE_PROJECT_MILESTONE = "UPDATE_PROJECT_MILESTONE";
export const GET_PROJECT_SUBTASK = "GET_PROJECT_SUBTASK";
export const ADD_PROJECT_SUBTASK = "ADD_PROJECT_SUBTASK";
export const REMOVE_PROJECT_SUBTASK = "REMOVE_PROJECT_SUBTASK";
export const UPDATE_PROJECT_SUBTASK = "UPDATE_PROJECT_SUBTASK";